"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import SectionTitle from "@/components/common/section-title";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

              <EspaceProTitleCard title={"Tourisme & Capital Humain"}
                                  middleBreadcrumbs={[{title: "Devenir Partenaire", link: "/espace-pro/devenir-partenaire"}]}
                                  description={"Participer à la création d’une industrie touristique durable."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <p className={"text-normal text-justify mt-4"}>
                  Notre secteur d’activités est en constante évolution d’où l’apparition de nouvelles aptitudes et de nouveaux métiers. Être un acteur dans l’industrie touristique implique des compétences techniques, propres à notre métier qui demande de se former de manière continue pour pouvoir améliorer ses performances au travail. Aussi des notions en compétences non techniques que ce soit pour booster son leadership, se familiariser à la gestion des réseaux sociaux ou avoir des notions en développement personnel, assure d’être plus polyvalent, plus autonome… En somme : plus efficace au travail.
<br/>
<br/>
                  L’office grâce à son réseau de partenaire est en relation avec une équipe d’experts spécialisés dans différents domaines et présente pour vous conseiller et assurer un suivi de votre activité.
<br/>
<br/>
                  Que vous soyez un socioprofessionnel, un porteur de projet ou un acteur touristique en devenir, l’équipe de l’office de tourisme met à votre disposition toutes les ressources pouvant vous être utiles pour un accompagnement professionnel grâce à son offre de services sous forme de parcours en plusieurs rendez-vous.
<br/>
<br/>
                  Une idée, un projet, un besoin, nous vous proposons des services adaptés à votre activité afin de valoriser les métiers du tourisme.
              </p>

              <SectionTitle title={"Renforcement des capacités du personnel"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  Le capital humain est la clé du succès de la transformation structurelle de l’économie touristique.

                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1">Faire des métiers du tourisme une filière d’excellence
                      </li>
                      <li className="li1">Éveiller les consciences et susciter des vocations
                      </li>
                  </ul>

                  (Suite texte sur le site internet)
              </div>

              <SectionTitle title={"Parcours \"Ateliers prof.\""} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  Ce parcours de professionnalisation vous permet de découvrir et d’acquérir des connaissances et des compétences à la mise en place ou à la poursuite de votre activité dans divers domaines tels que : hygiène, sécurité sanitaire, accueil, gestion de relation client, argumentaire de vente, développement de point de vente, démarche qualité, business model, etc.
<br/>
<br/>
                  Ce parcours est ouvert à tous.

                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1">Durée : 1h30 à 3h
                      </li>
                      <li className="li1">Tarif : / personne – limité à 10 personnes
                      </li>
                  </ul>
              </div>

              <SectionTitle title={"Parcours \"Echanges de pratiques\""} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  Ces temps d’échanges conviviaux vous permettront de rencontrer d’autres acteurs, d’échanger vos bonnes pratiques et évoquer vos expériences.
<br/>
<br/>
                  ce parcours est ouvert à tous

                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1">Duree : 1h50
                      </li>
                      <li className="li1">Tarif : gratuit – limite a 10 personnes
                      </li>
                  </ul>
              </div>

              <SectionTitle title={"Parcours « Sur le terrain »"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  Bien recevoir nos visiteurs, nos clients, les inciter à goûter, humer, ressentir le territoire, leur faire partager nos connaissances, nos expériences, nos enthousiasmes, c’est ce qui nous importe tous.
<br/>
<br/>
                  Une connaissance affinée de la terre et des hommes, du patrimoine et des savoir-faire est la valeur ajoutée de l’accueil et donnera envie au client de revenir.
<br/>
<br/>
                  La découverte du territoire à travers des éductours sur mesure pour aller à la rencontre des acteurs et de quelques pépites parfois insoupçonnées.
<br/>
<br/>
                  Ce parcours est ouvert à tous.

                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1">Durée : 3 jours -2 nuits
                      </li>
                      <li className="li1">Tarif : /personne – limité à 20 personnes
                      </li>
                  </ul>
              </div>

              <SectionTitle title={"Parcours \"Porteurs de projet\""} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  Vous avez une idée ou un projet mais vous ne savez pas par où commercer, où chercher et trouver l’information. Pour faire avancer votre projet, nous vous mettons en relation avec des interlocuteurs spécialisés afin d’obtenir en une 1/2 journée toutes les informations nécessaires à sa réalisation.

                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1">Sur demande et fonction du projet
                      </li>
                      <li className="li1">Gratuit
                      </li>
                  </ul>
              </div>

              <SectionTitle title={"Parcours « Communication, Marketing et Evènementiel »"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  Nous vous proposons certains aspects de marketing spécifiques à votre métier lors de séminaires ou d’atelier de formation pour appréhender au mieux ces notions et les intégrer dans vos stratégies.

                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1">Durée : 1h30 à 3h
                      </li>
                      <li className="li1">Tarif : / personne – limité à 10 personnes
                      </li>
                  </ul>
              </div>

              <SectionTitle title={"Parcours « Animation numérique »"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  L’arrivée d’Internet a bousculé beaucoup de choses dans le tourisme en prenant une place de plus en plus importante dans les choix et le comportement des voyageurs. Il est donc aujourd’hui très important d’être présent sur le web et d’optimiser sa présence sur différents supports.
<br/>
<br/>
                  Au programme : visibilité sur le web, présence sur les réseaux sociaux, e-réputation, gestion relation client, prise de vue…

                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1">Durée : 1h30 à 3h
                      </li>
                      <li className="li1">Tarif : / personne – limité à 10 personnes
                      </li>
                  </ul>
                  Mais aussi les parcours : HACCP, démarche qualité pour client interne et externe, réinventer son business model etc…
<br/>
<br/>
                  L’Office à votre service
              </div>

          </SectionPage>

          </div>
  );
}
